import { writable } from "svelte/store";
import type { InventoryStatus } from "@shared/types/InventoryStatus";

export interface InventoryStatusStoreState {
  loadingInventoryStatuses: boolean;
  inventoryStatuses: { [id: number]: InventoryStatus[] };
  numberOfSkusInStock: { [id: number]: number };
}

const defaultStoreState: InventoryStatusStoreState = {
  loadingInventoryStatuses: false,
  inventoryStatuses: {},
  numberOfSkusInStock: {},
};

let InventoryStatusStore = writable<InventoryStatusStoreState>(defaultStoreState);
export default InventoryStatusStore;
